import { render, staticRenderFns } from "./tiposFornecedor.vue?vue&type=template&id=74fb3a40"
import script from "./tiposFornecedor.vue?vue&type=script&lang=js"
export * from "./tiposFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports